
export const APPLICANT_NEXT_STEP: Record<string, string> = {
    INCOMPLETE: 'Finish the application and pay application fee',
    PENDING: 'Liberty Rent is reviewing your Application and will send an update shortly',
    APPROVED: 'Pay the Access Fee and get ready to move in',
    DENIED: 'We are sorry but you did not meet our minimum requirements',
    EXPIRED: 'Expired',
    AWAITING: 'Correct your application and resubmit for review',
    NOT_STARTED: 'Please complete the application',
    CANCELLED: 'Cancelled',
}

export const getApplicantNextStep = (status: string | undefined): string => {
    if (!status) return ''
    return APPLICANT_NEXT_STEP[status] || ''
}
